import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { isPC } from '../../../helpers/Utils';
import './CoreLayout.scss';
import { onDeviceChanged } from '../../../redux/modules/device';
// import assets from '../../../helpers/Assets';
import DialogContainer from './DialogContainer';


const mapStateToProps = (state) => ({
  device: state.device.current,
  pathName: window.location.pathname

})

const mapActionCreators = {
  onDeviceChanged
}

const BLACK_PATHS_PC = ['/project', '/projectInfo', '/security', '/submit'];
const BLACK_PATHS_MOBILE = ['/project', '/projectInfo', '/submit'];


class CoreLayout extends Component {
  static defaultProps = {
  }

  state = {
  }

  componentWillMount = () => {
    this.addResizeListener();
  }

  componentDidMount() {
    this.resetRemAndNotify();
    this.setState({bgColor: this.getHeaderBgColor(this.props)});
  }

  componentWillReceiveProps(newProps){
    if(this.props.pathName !== newProps.pathName || this.props.device !== newProps.device){
      this.setState({ bgColor: this.getHeaderBgColor(newProps) });
    }
  }

  addResizeListener = () => {
    var resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvent, this.resetRemAndNotify, false);
    document.addEventListener('DOMContentLoaded', this.resetRemAndNotify, false);
  }

  resetRemAndNotify = () => {
    var _root = document.documentElement;
    var clientWidth = _root.clientWidth;
    const pc = isPC() && clientWidth > 750;
    _root.style.fontSize = pc ? (clientWidth / 28.8) + 'px' : (clientWidth / 7.5) + 'px';
    const currentDevice = pc ? 'pc' : 'mobile';
    if (this.props.device !== currentDevice) {
      this.props.onDeviceChanged(currentDevice);
    }
  }

  getHeaderBgColor = (props) => {
    const { device } = props;
    const path = window.location.pathname;
    const PATHS = device === 'pc' ? BLACK_PATHS_PC : BLACK_PATHS_MOBILE;
    if (PATHS.includes(path)) {
      return '#13161B';
    }
    return 'transparent';
  }

  onScroll = (e) => {
    if(e.target.className !== 'page_container'){
      return;
    }
    const { device, pathName } = this.props;
    const PATHS = device === 'pc' ? BLACK_PATHS_PC : BLACK_PATHS_MOBILE;
    if (!PATHS.includes(pathName)) {
      let op = e.target.scrollTop / 100;
      op = op > 1 ? 1 : op.toFixed(2);
      let bgColor = `rgba(19, 22, 27, ${op})`
      this.setState({ bgColor });
    }
  }

  render() {
    const { children, /*device*/ } = this.props;
    // const { bgColor } = this.state;
    return <div className='core_container' onScroll={this.onScroll}>
      {children}
      {/* {device === 'pc' ? <HeaderPC menu={MENU} bgColor={bgColor} /> : <HeaderMobile menu={MENU} bgColor={bgColor}/>} */}
      <DialogContainer/>
    </div>
  }
}

export default connect(mapStateToProps, mapActionCreators)(CoreLayout);

